import type { ReactNode } from 'react';
import { ProductCatalogFilteringProvider } from './hooks/useProductCatalogFiltering';
import type { ProductCatalogProductFilter } from './hooks/useProductCatalogFiltering';
import { ProductCatalogProductsProvider } from './hooks/useProductCatalogProducts';

export default function ProductCatalogProvider(props: {
  children: ReactNode
  productFilter?: ProductCatalogProductFilter
}) {
  return <ProductCatalogFilteringProvider productFilter={props.productFilter}>
    <ProductCatalogProductsProvider>
      {props.children}
    </ProductCatalogProductsProvider>
  </ProductCatalogFilteringProvider>;
}
